import { BounceLoader, PulseLoader } from "react-spinners";
import { MainContainer } from "./Loader.styled";
import { theme } from "../../Theme";

interface LoaderProps {
	color?: React.CSSProperties["color"];
	controlSize?: "xxl" | "xl" | "l" | "m" | "sm" | "xsm";
}

const Loader = ({ color = theme.colors.textPrimary, controlSize = "m" }: LoaderProps) => {
	let size = 18;
	switch (controlSize) {
		case "xxl":
		case "xl":
		case "l":
			size = 18;
			break;
		case "m":
			size = 10;
			break;
		case "sm":
		case "xsm":
			size = 8;
			break;
	}

	return (
		<MainContainer $isFullPage={controlSize == "xxl"}>
			<PulseLoader color={color} size={size} style={{
				//rotate
				transform: "rotate(0deg)",
			}} />
		</MainContainer>
	);
};

export default Loader;
